// Wishlist drawer open/close state. Same shape as lib/cart-drawer — separate
// module because the wishlist drawer is a distinct UI surface from the cart.

'use client';

import { useSyncExternalStore } from 'react';

let isOpen = false;
const listeners = new Set<() => void>();

function emit() {
  for (const fn of listeners) fn();
}

export function openWishlistDrawer(): void {
  if (isOpen) return;
  isOpen = true;
  emit();
}

export function closeWishlistDrawer(): void {
  if (!isOpen) return;
  isOpen = false;
  emit();
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function getSnapshot(): boolean {
  return isOpen;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useWishlistDrawer(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
